import styled from 'styled-components';

import {
  focusRing,
  panelColors,
  panelFont,
  waitingPillLate,
} from './SedeList.style';

export const OverviewButton = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 64px;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 10px 12px;
  border: 1px solid ${panelColors.border};
  border-radius: 14px;
  background: #FFFFFF;
  color: ${panelColors.text};
  text-align: left;
  cursor: pointer;
  ${focusRing}

  &:hover {
    background: ${panelColors.surface};
  }
`;

export const OverviewBadge = styled.span`
  flex: none;
  width: 44px;
  height: 44px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1E2A4A;
  color: #FFFFFF;
`;

export const OverviewText = styled.span`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const OverviewTitle = styled.span`
  font-family: ${panelFont};
  font-weight: 700;
  font-size: 15px;
  line-height: 1.2;
  color: ${panelColors.text};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// May take two lines on a phone, next to the waiting pill.
export const OverviewSubtitle = styled.span`
  font-family: ${panelFont};
  font-weight: 400;
  font-size: 12px;
  line-height: 1.2;
  color: ${panelColors.textSoft};
`;

export const OverviewWaiting = styled.span`
  flex: none;
  padding: 4px 10px;
  border-radius: 999px;
  font-family: ${panelFont};
  font-weight: 600;
  font-size: 12px;
  line-height: 1.2;
  white-space: nowrap;
  ${waitingPillLate}
`;
